var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-full text-center text-gray-600 mt-5 py-5"},[_vm._v("\n    © 2016-2019 Viral New Service.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }